import * as form from '../form';

export const substanceAlcoholAdditional = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        TreatmentProviderName: form.text(xitem.TreatmentProviderName),
        TreatmentProviderAddress: form.location(xitem.TreatmentProviderAddress),
        AgencyName: form.text(xitem.AgencyName),
        AgencyAddress: form.location(xitem.AgencyAddress),
        UseSameAddress: form.branch(xitem.UseSameAddress),
        CounselingDates: form.daterange(xitem.CounselingDates),
        CompletedTreatment: form.branch(xitem.CompletedTreatment),
        NoCompletedTreatmentExplanation: form.textarea(xitem.NoCompletedTreatmentExplanation),
        Comments: form.textarea(xitem.Comments),
      },
    };
  });
  return {
    ReceivedTreatment: form.branch(data.ReceivedTreatment),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
  };
};
